// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"9bf1e4f7","247":"4c275757","453":"d7446e4a","795":"bd69597d"}[chunkId] + ".chunk.js";
};